
import React from 'react'
import Card from './Component/Card';
function App() {
  return (
    <div className="App">
    <Card/>

    </div>
  );
}

export default App;
/*  <header>
      <Navbar/>
      <img className="w-screen h-screen object-cover" src={header} alt="sunnyside image"/>
      </header>
      <section className="flex flex-col md:flex-row">
        <div className="w-full md:w-6/12 h-auto p-10 text-center md:text-left md:my-10 md:mt-32 ">
          <h1 className="text-3xl font-fraunces  text-black m-2">Transform your brand</h1>
          <p className="text-darkgrayblue text-sm font-barlow m-2 ">
            We are a full-service creative agency specializing in helping brands grow fast.Engage your clients through compelling visuals that do most of the marketing for you:
          </p>
          <h3 className=" font-fraunces text-lg text-black m-2 z-40">Learn more</h3>
          <div className="border-4 rounded-full w-28 ml-1 -mt-5 border-yellow z-0"></div>

        </div>
        <div className="w-full md:w-6/12 h-auto">
          <img src={transform} className="w-full h-full" alt="dfc"/>
        </div>
      </section>
      <section className="flex flex-col  md:flex-row-reverse">
        <div className="w-full md:w-6/12 h-auto p-10 text-center md:text-left md:my-10 md:mt-32 ">
          <h1 className="text-3xl font-fraunces  text-black m-2">Stand out to the right audience</h1>
          <p className="text-darkgrayblue text-sm font-barlow m-2 ">
            Using a collaborative formula of designers,researchers,photographers,videographers and copywriters.We'll build and extend your brand in digital places.
          </p>
          <h3 className=" font-fraunces text-lg text-black m-2 z-40">Learn more</h3>
          <div className="border-4 rounded-full w-28 ml-1 -mt-5 border-softred z-0"></div>

        </div>
        <div className="w-full md:w-6/12 h-auto">
          <img src={stand} className="w-full h-full" alt="dfc"/>
        </div>
      </section>
      <section className="flex flex-col md:flex-row">
        <div className="relative w-screen md:w-6/12 ">
          <img src={graphic} className="w-full" alt="cdfss"/>
          <div className="absolute bottom-5 text-center ">
            <h1 className="text-xl font-fraunces text-darkcyan ">Graphic Design</h1>
            <p className="text-md font-barlow text-moderatecyan ">Great design makes you memorable.We deliver artwork that underscores your brand message and captures potential clients attention.</p>
          </div>
        </div>
        <div className="relative w-screen md:w-6/12 ">
        <img src={photography} className="w-full" alt="cdfss"/>
        <div className="absolute bottom-5 text-center">
          <h1 className="text-xl font-fraunces text-darkcyan ">Photography</h1>
          <p className="text-md font-barlow text-moderatecyan ">Increase your credibly by getting the most stunning,high-quality images that improve your business image.</p>
        </div>
        </div>

      </section>*/